import Swal from 'sweetalert2';
import moment from 'moment';
import 'select2'; // globally assign select2 fn to $ element
import 'select2/dist/css/select2.css';

export default {
  init() {

  },
  finalize() {
    moment.locale('fr');

    // eslint-disable-next-line no-unused-vars
    function showCouleur(couleur) {
      return `<span style='display: block; width: 20px; height: 20px; min-width: 20px; min-height: 20px; background-color: ${couleur}; margin-left: 0.5rem;'></span>`;
    }

    // eslint-disable-next-line no-unused-vars
    const Toast = Swal.mixin({
      toast: true,
      position: 'top-end',
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer);
        toast.addEventListener('mouseleave', Swal.resumeTimer);
      },
    });

    $(document).on('click', '.add', function () {
      $.ajax({
        type: 'POST',
        // eslint-disable-next-line no-undef
        url: ajax_object.ajaxurl,
        beforeSend: function () {
          Toast.fire({
            icon: 'info',
            title: 'Chargement en cours',
            timer: false,
          });
        },
        data: {
          // eslint-disable-next-line no-undef
          security_edit_salle: ajax_object.ajax_nonce,
          action: 'edit_salle',
        },
        success: function (response_edit) {
          if (response_edit.success) {
            Swal.fire({
              title: 'Ajout d\'une nouvelle salle',
              html: response_edit.html,
              showCancelButton: true,
              cancelButtonText: 'Annuler',
              confirmButtonText: 'Enregistrer',
              confirmButtonColor: '#2e7d32',
              preConfirm: () => {
                return {
                  // eslint-disable-next-line no-undef
                  security_create_salle: ajax_object.ajax_nonce,
                  action: 'create_salle',
                  nom: $('#nom').val(),
                  emplacement: $('#emplacement').val(),
                  couleur: $('#couleur').val(),
                };
              },
            }).then((infos) => {
              if (infos.isConfirmed) {
                infos = infos.value;
                $.ajax({
                  type: 'POST',
                  // eslint-disable-next-line no-undef
                  url: ajax_object.ajaxurl,
                  data: infos,
                  success: function (response_update) {
                    if (response_update.success) {
                      $('#salles tbody').append(response_update.html);
                      Toast.fire({
                        icon: 'success',
                        title: 'Salle créée',
                      });
                    } else {
                      Toast.fire({
                        icon: 'error',
                        title: `${response_update.message}`,
                      });
                    }
                  },
                });
              }
            });
          } else {
            Toast.fire({
              icon: 'error',
              title: `${response_edit.message}`,
            });
          }
        },
      });
    });

    $('#salles').on('click', 'tr[data-id] .edit', function () {
      var tr = $(this).closest('tr');
      var salle_id = tr.data('id');
      $.ajax({
        type: 'POST',
        // eslint-disable-next-line no-undef
        url: ajax_object.ajaxurl,
        beforeSend: function() {
          Toast.fire({
            icon: 'info',
            title: 'Chargement en cours',
            timer: false,
          });
        },
        data: {
          // eslint-disable-next-line no-undef
          security_edit_salle: ajax_object.ajax_nonce,
          action: 'edit_salle',
          salle: salle_id,
        },
        success: function (response_edit) {
          if (response_edit.success) {
            Swal.fire({
              title: `Mise à jour des informations de ${response_edit.salle.nom}`,
              html: response_edit.html,
              showCancelButton: true,
              cancelButtonText: 'Annuler',
              confirmButtonText: 'Mettre à jour',
              confirmButtonColor: '#2e7d32',
              preConfirm: () => {
                return {
                  // eslint-disable-next-line no-undef
                  security_update_salle: ajax_object.ajax_nonce,
                  action: 'update_salle',
                  salle_id: salle_id,
                  nom: $('#nom').val(),
                  emplacement: $('#emplacement').val(),
                  couleur: $('#couleur').val(),
                };
              },
            }).then((infos) => {
              if (infos.isConfirmed) {
                infos = infos.value;
                $.ajax({
                  type: 'POST',
                  // eslint-disable-next-line no-undef
                  url: ajax_object.ajaxurl,
                  data: infos,
                  success: function (response_update) {
                    if (response_update.success) {
                      tr.replaceWith(response_update.html);
                      Toast.fire({
                        icon: 'success',
                        title: 'Salle mise à jour',
                      });
                    } else {
                      Toast.fire({
                        icon: 'error',
                        title: `${response_update.message}`,
                      });
                    }
                  },
                });
              }
            });
          } else {
            Toast.fire({
              icon: 'error',
              title: `${response_edit.message}`,
            });
          }
        },
      });
    });

    $('#salles').on('click', 'tr[data-id] .delete', function () {
      var tr = $(this).closest('tr');
      var salle_id = tr.data('id');
      var salle_nom = tr.data('nom');
      var salle_reservations = tr.data('reservations');
      var html = `Souhaitez-vous supprimer "${salle_nom}"`;
      if (salle_reservations) {
        html = html.concat(
          ` ainsi que les ${salle_reservations} créneaux reservés dans cette salle`
        );
      }
      html = html.concat(' ?');
      Swal.fire({
        title: `Suppression de ${salle_nom}`,
        html: html,
        showCancelButton: true,
        cancelButtonText: 'Annuler',
        confirmButtonText: 'Supprimer',
        confirmButtonColor: '#dd6b55',
      }).then((infos) => {
        if (infos.isConfirmed) {
          $.ajax({
            type: 'POST',
            // eslint-disable-next-line no-undef
            url: ajax_object.ajaxurl,
            beforeSend: function() {
              Toast.fire({
                icon: 'info',
                title: 'Suppression en cours',
                timer: false,
              });
            },
            data: {
              // eslint-disable-next-line no-undef
              security_delete_salle: ajax_object.ajax_nonce,
              action: 'delete_salle',
              salle: salle_id,
            },
            success: function (response_delete) {
              if (response_delete.success) {
                tr.remove();
                Toast.fire({
                  icon: 'success',
                  title: 'Salle supprimée',
                });
              } else {
                Toast.fire({
                  icon: 'error',
                  title: `${response_delete.message}`,
                });
              }
            },
          });
        }
      });
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/gestion_salle.js